// extracted by mini-css-extract-plugin
export default {"bodyAbout":"About_bodyAbout__LC6eT","card":"About_card__q6i2a"};